import { fetchGetSupplyOrderDetailItem } from 'features/SupplyOrder/redux/outboundSOAddEdit'
import { PutSupplyOrderDetailRequestType } from 'features/SupplyOrder/services/outboundSO'
import { useParams } from 'react-router-dom'
import { shallowEqual, useAppDispatch, useAppSelector } from 'store'

const useTable = () => {
  const { id } = useParams<{ id: string }>()
  const dispatch = useAppDispatch()
  const { data, products, form } = useAppSelector((state) => state.outboundSOAddEdit, shallowEqual)
  const { query, item } = products

  const supplyOrderRequest: PutSupplyOrderDetailRequestType['supplyOrderRequest'] = {
    createdBy: data?.supplyOrderCreatedBy || '',
    locationDestinationId:
      form.soType.toLowerCase() === 'return'
        ? form.poReff?.vendorId || 0
        : form.destination?.location_id || 0,
    locationOriginId: form.origin?.location_id || 0,
    remarks: form?.remarks?.code || '',
    poRef: form?.poReff || {},
    requestBy: form?.email || '',
    shippingInstructions: form?.shippingInstructions || '',
    soDate: form.soDate ? form.soDate.getTime() : 0,
    soReff: form.soReff || '',
    soType: form.soType || '',
    status: data?.supplyOrderStatus || '',
  }

  const handleChangePage = (page: number) => {
    dispatch(
      fetchGetSupplyOrderDetailItem({
        supplyOrderId: Number(id),
        params: {
          pageIndex: page - 1,
        },
      }),
    )
  }

  const handleChangeRowsPerPage = (rowsPerPage: number) => {
    dispatch(
      fetchGetSupplyOrderDetailItem({
        supplyOrderId: Number(id),
        params: {
          pageIndex: 0,
          pageSize: rowsPerPage,
        },
      }),
    )
  }

  return {
    query,
    item,
    supplyOrderRequest,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}

export default useTable
